import { StyledHeightController } from './HeightController.style';

const HeightController = ({ itemRelativeHeight = 100 }) => (
  <StyledHeightController $itemRelativeHeight={itemRelativeHeight} />
);

export default HeightController;
